export default {
  methods: {
    formatArea(measurement) {
      if (measurement != undefined && measurement != null) {
        return measurement > 100
          ? (measurement / 1000).toFixed(2) + "km"
          : measurement.toFixed(2) + "m";
      } else {
        return 0;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/generic.js